import "core-js/modules/es.array.push.js";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import { getFullNameUser } from "@/js/user/user.js";
import { emptyCellContent, stockReservationTypes } from "@/js/lists.ts";
export default {
  name: "PurchaseOrderStocksModal",
  components: {},
  props: {
    loggedUserData: Object,
    item: Object,
    purchaseOrder: Object
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      stocks: [],
      headers: [{
        text: "Ref. warehouse",
        value: "reference_warehouse",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Available",
        value: "quantity",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Committed",
        value: "quantity_committed",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Warehouse",
        value: "warehouse.name",
        align: "center"
      }, {
        text: "Intended countries",
        value: "total_implanted_countries",
        align: "center",
        width: "200px"
      }, {
        text: "Reservation",
        value: "reservation_type",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false
      }],
      lastStockIdCreated: null,
      stockReservationTypes: stockReservationTypes,
      emptyCellContent: emptyCellContent
    };
  },
  computed: {},
  created: function created() {
    this.stocks = this.item.stocks;
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    reload: function reload() {
      this.$emit("reloaded");
    },
    refresh: function refresh(stocks) {
      this.stocks = stocks;
    },
    stockDetails: function stockDetails(idStock) {
      this.$router.push({
        name: "adminStockDetails",
        query: {
          id_stock: idStock
        }
      });
    },
    getFullNameUser: getFullNameUser
  }
};